var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalDeathIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.635,
    height: 50.074,
    viewBox: "0 0 31.635 35.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9079",
    "data-name": "Group 9079",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 0.609, 28.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M21.688.407c-.658,1.317-1.332,2.63-1.932,3.974a11.6,11.6,0,0,0-.489,1.812l.119.037.444-.929c0,.756.007,1.382,0,2.007a.49.49,0,0,0,.3.517,7.7,7.7,0,0,1,1.159.7c.714.533,1.407,1.092,2.092,1.661a2.366,2.366,0,0,1,.367.509L19.6,10.86c.688.348,1.33.645,1.945.989a5.133,5.133,0,0,1,2.723,2.835,14.818,14.818,0,0,1,.318,1.448c0,.019-.017.041-.028.063l-.252-.189c-.219.454-.407.9-.637,1.316-1.36,2.477-3.8,3.664-6.11,5.112l.065-.376L14.9,23.1l.334-.55H12.487l-.021-.086.766-.46-2.962-.169v-.165l.567-.1C6.252,21,3.262,18.686,2.381,13.936l.655.742.057-.058-.561-1.108.059-.032L3,14.021a4.723,4.723,0,0,0-.364-1.062A23.984,23.984,0,0,1,1.573,8.414C.819,4.8,22.731-1.685,21.688.407ZM0,5.66c.276,1.166.559,2.226.77,3.3.434,2.2.671,4.455,1.278,6.606A8.68,8.68,0,0,0,8.142,21.8c.8.246,1.627.433,2.448.624a8.749,8.749,0,0,0,1.008.1l-.576.088a5.144,5.144,0,0,0,2.77.717l-.4.223a5.953,5.953,0,0,0,2.92-.346l-.326.389.049.075c.4-.166.8-.319,1.187-.5a20.121,20.121,0,0,0,5.162-3.2A6.808,6.808,0,0,0,24.5,16.895l.266.808a1.786,1.786,0,0,0,.43-1.431,1.588,1.588,0,0,1,.567-1.562c.352-.368.778-.665,1.158-1.008.423-.381.83-.781,1.238-1.167l.469-1.241a.737.737,0,0,0,.037-.433c-.044-.262-.124-.52-.189-.779-.224.07-.447.146-.673.207-.156.042-.4.142-.46.08l-.773.415c-.612.039-1.088.077-1.564.091a.388.388,0,0,1-.291-.133,11.2,11.2,0,0,0-3.461-3.048A.6.6,0,0,1,21,7.408c-.164-.5-.3-1-.448-1.5l.109-.057.09-1.532A6.782,6.782,0,0,1,21.3,2.675",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M.019,8.415A23.97,23.97,0,0,0,1.081,12.96a4.734,4.734,0,0,1,.364,1.062l-.408-.541-.059.032.561,1.108-.057.058-.656-.743C1.707,18.686,4.7,21,9.284,21.564l-.567.1v.165L11.678,22l-.766.46.021.086h2.746l-.334.55,2.722-1.037L16,22.436c2.315-1.448,4.751-2.635,6.11-5.112.229-.42.418-.863.637-1.316L23,16.2c.011-.022.032-.045.028-.063a14.793,14.793,0,0,0-.318-1.448,5.132,5.132,0,0,0-2.723-2.836c-.616-.344-1.257-.641-1.945-.989l4.144-.165a2.376,2.376,0,0,0-.367-.509c-.685-.568-1.378-1.127-2.092-1.66a7.71,7.71,0,0,0-1.159-.7.49.49,0,0,1-.3-.517c.009-.625,0-1.252,0-2.007l-.444.929-.119-.037A11.608,11.608,0,0,1,18.2,4.38c.6-1.344,1.274-2.656,1.932-3.974C21.176-1.685-.735,4.8.019,8.415ZM12.826,3.931,12.89,3.8l1.486.794-.058.113c-.245-.115-.495-.221-.735-.348C13.326,4.229,13.078,4.076,12.826,3.931Z",
    transform: "translate(1.555 0)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M.972,0,0,.289C.156.7.392.651.972,0Z",
    transform: "translate(24.849 13.263)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4507",
    "data-name": "Rectangle 4507",
    width: 1.044,
    height: 5.952,
    transform: "translate(18.152 12.934)",
    fill: "#ff5852"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4508",
    "data-name": "Rectangle 4508",
    width: 1.093,
    height: 5.952,
    transform: "translate(15.698 16.457) rotate(-90)",
    fill: "#ff5852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9911",
    "data-name": "Path 9911",
    d: "M2.917,3.837c.6-.53,1.174-1.045,1.758-1.547A3.841,3.841,0,0,0,6.24,0,6.059,6.059,0,0,1,3.152.744C2.108.724,1.064.6,0,.553,1.278,1.4,2.515,2.282,2.917,3.837ZM3.953,2.456c-.58.652-.816.7-.972.289Z",
    transform: "translate(21.868 10.807)",
    fill: "#113252"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDeathIcon);
export default __webpack_public_path__ + "static/media/totalDeathIcon.d156da3ba59cbdfb1afb8690dcf192c5.svg";
export { ForwardRef as ReactComponent };